/**
 * Quick task 260727-gob — caller-scoped "my reports" feed.
 *
 * Wraps GET /api/tasks/my-reports. Query key includes the effective user id
 * (impersonated when active, otherwise own) so the cache doesn't bleed one
 * persona's reports into another's view — same pattern as useMyTasks /
 * useUnassignedTasks.
 */
import { useQuery } from '@tanstack/react-query';
import { getMyReports, type MyReport } from '../services/api/tasks';
import { useAuthOptional } from '../services/authContext';

export const MY_REPORTS_BASE_KEY = ['tasks', 'my-reports'] as const;

export function useMyReports() {
  const auth = useAuthOptional();
  const effectiveUserId = auth?.impersonatedUser?.id ?? auth?.user?.id ?? null;
  return useQuery<MyReport[]>({
    queryKey: [...MY_REPORTS_BASE_KEY, effectiveUserId],
    queryFn: getMyReports,
    staleTime: 30_000,
    enabled: effectiveUserId != null,
  });
}

export type { MyReport };
